<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="238" height="184" viewBox="0 0 238 184" fill="none">
    <path d="M237 184V1H-6.07967e-06" stroke="white" />
  </svg>
</template>
